import React from 'react';
import { useRefresh } from 'react-admin';
import { Button } from '@material-ui/core';
import Refresh from '@material-ui/icons/Refresh';

const RefreshButton = () => {
    const refresh = useRefresh();
    const handleClick = () => {
        refresh();
    }
    return <Button onClick={handleClick} startIcon={<Refresh />}>Refresh</Button>;
};

export default RefreshButton;